var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { classMap, Component, CustomElement, Event, html, ifDefined, nothing, Prop, State } from '@sick-davinci/ce-decorators';
import { IconRef } from '@sick-davinci/basic-elements';
import { style } from './Header.style';
import { SICK_LOGO } from '../assets/logo';
import { standardButtons } from './buttons';
import { icon_menu as paneToggleIcon } from '@sick-davinci/material-icons/navigation/menu.icon';
export * from './model';
/**
 * The `davinci-core-header` generates a DaVinci application-header
 *
 * @example
 * ```html
 * <davinci-core-header logo-title="Sick AG Waldkirch" app-name="HeaderDemo" show-pane-toggle search about language apps user menu></davinci-core-header>
 * ```
 */
export let Header = (_dec = Component({
  style: [style],
  tag: 'davinci-core-header',
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", Boolean), _dec22 = Prop(), _dec23 = Reflect.metadata("design:type", Boolean), _dec24 = Prop(), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Prop(), _dec27 = Reflect.metadata("design:type", Object), _dec28 = Event('pane-toggle'), _dec29 = Reflect.metadata("design:type", Object), _dec30 = Event('button-click'), _dec31 = Reflect.metadata("design:type", Object), _dec32 = State(), _dec33 = Reflect.metadata("design:type", Object), _dec34 = State(), _dec35 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Header extends CustomElement {
  constructor(...args) {
    super(...args);
    /**
     * Determines, if the pane-toggle (on the left side of the header) is shown.
     */
    _initializerDefineProperty(this, "showPaneToggle", _descriptor, this);
    /**
     * Determines, if the paneToggle is highlighted.
     */
    _initializerDefineProperty(this, "paneToggleActive", _descriptor2, this);
    /**
     * URL for the logo-image file
     */
    _initializerDefineProperty(this, "logoUrl", _descriptor3, this);
    /**
     * Title- or alt-text for the logo
     */
    _initializerDefineProperty(this, "logoTitle", _descriptor4, this);
    /**
     * Application-title
     */
    _initializerDefineProperty(this, "appName", _descriptor5, this);
    /**
     * (De)activate the standard header button "about"
     * Id in event "button-click": std_about
     */
    _initializerDefineProperty(this, "about", _descriptor6, this);
    /**
     * (De)activate the standard header button "apps"
     * Id in event "button-click": std_apps
     */
    _initializerDefineProperty(this, "apps", _descriptor7, this);
    /**
     * (De)activate the standard header button "language"
     * Id in event "button-click": std_language
     */
    _initializerDefineProperty(this, "language", _descriptor8, this);
    /**
     * (De)activate the standard header button "menu"
     * Id in event "button-click": std_menu
     */
    _initializerDefineProperty(this, "menu", _descriptor9, this);
    /**
     * (De)activate the standard header button "search"
     * Id in event "button-click": std_search
     */
    _initializerDefineProperty(this, "search", _descriptor10, this);
    /**
     * (De)activate the standard header button "user"
     * Id in event "button-click": std_user
     */
    _initializerDefineProperty(this, "user", _descriptor11, this);
    /**
     * Setting buttonTitles replaces the default title-attributes of the standard-buttons, whose ids are listed in the object.
     * Setting a title to undefined or null keeps the default title, setting it to an empty string "disables" it.
     */
    _initializerDefineProperty(this, "buttonTitles", _descriptor12, this);
    /**
     * Adds custom function buttons to the header. All custom buttons are always rendered in a row, as listed in the array.
     * Depending on the configuration of the default header buttons they may follow the default search button, otherwise they
     * are rendered before the standard buttons.
     * Overall there is a limit of 8 buttons that can be displayed in the header. So if all 6 standard buttons are activated,
     * only 2 additional customFunctions are rendered in the header.
     *
     * Example: [{ id: 'settings', title: 'SETTINGS', iconSrc: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
     *  <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4
     *  1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg>' }]
     * The iconSrc property must be a raw svg string or a dataurl to an either base64 or url encoded svg.
     */
    _initializerDefineProperty(this, "customFunctions", _descriptor13, this);
    /**
     * Emits a CustomEvent<Boolean>, when the SidePaneToggle is clicked.
     * Payload is the current value of paneToggleActive
     */
    _initializerDefineProperty(this, "paneToggleEvent", _descriptor14, this);
    /**
     * Emits a CustomEvent<FunctionButtonEvent>, when a header button (e.g. customFunction or standard button) was clicked.
     * FunctionButtonEvent.id for standard buttons are: std_search, std_about, std_language, std_apps, std_user, std_menu
     */
    _initializerDefineProperty(this, "buttonClickEvent", _descriptor15, this);
    _initializerDefineProperty(this, "customFunctionsToRender", _descriptor16, this);
    _initializerDefineProperty(this, "functionButtons", _descriptor17, this);
    _defineProperty(this, "_toggleNavigationPane", event => {
      event.stopPropagation();
      this.paneToggleActive = !this.paneToggleActive;
      this.paneToggleEvent.emit(this.paneToggleActive);
    });
  }
  componentFirstRender() {
    this.observedElements = {
      header: this,
      left: this.shadowRoot.querySelector('.left'),
      right: this.shadowRoot.querySelector('.right')
    };
    Object.keys(this.observedElements).forEach(elementName => {
      new ResizeObserver(() => this._setAppNameVisibility()).observe(this.observedElements[elementName]);
    });
  }
  componentWillRender() {
    if (!this.customFunctions) {
      this.customFunctions = [];
    }
    this.customFunctionsToRender = [...this.customFunctions];
    this._prepareFunctionButtons();
  }
  render() {
    return html`
      <div class="left">
        ${this._renderPaneToggle()}
        ${this._renderLogo()}
      </div>
      <div class="right">
        <div class="app-name">${ifDefined(this.appName)}</div>
        ${this._renderDivider()}
        ${this._renderFunctionButtons()}
      </div>
    `;
  }
  _setAppNameVisibility() {
    const appNameEl = this.shadowRoot.querySelector('.app-name');
    const headerWidth = this.observedElements.header.getBoundingClientRect().width - 20;
    const leftWidth = this.observedElements.left.getBoundingClientRect().width;
    const rightWidth = this.observedElements.right.getBoundingClientRect().width;
    headerWidth <= leftWidth + rightWidth ? appNameEl.classList.add('hidden') : appNameEl.classList.remove('hidden');
  }
  _prepareFunctionButtons() {
    this._restrictCustomFuntions();
    this._buildFunctionButtonsList();
  }
  _countFunctionItems() {
    const buttonCount = {
      all: 0,
      internal: 0
    };
    if (this.search) {
      buttonCount.internal++;
    }
    if (this.about) {
      buttonCount.internal++;
    }
    if (this.language) {
      buttonCount.internal++;
    }
    if (this.apps) {
      buttonCount.internal++;
    }
    if (this.user) {
      buttonCount.internal++;
    }
    if (this.menu) {
      buttonCount.internal++;
    }
    buttonCount.all = buttonCount.internal + this.customFunctionsToRender.length;
    return buttonCount;
  }
  _restrictCustomFuntions() {
    const buttonCount = this._countFunctionItems();
    if (buttonCount.all > 8) {
      this.customFunctionsToRender.splice(8 - buttonCount.internal);
    }
  }
  _buildFunctionButtonsList() {
    const setButton = id => {
      if (this[id]) {
        let title = standardButtons[id].title; // default
        if (this.buttonTitles) {
          if (this.buttonTitles[id] !== undefined && this.buttonTitles[id] !== null) {
            title = this.buttonTitles[id];
          }
        }
        standardButtons[id].title = title;
        this.functionButtons.push(standardButtons[id]);
      }
    };
    this.functionButtons = [];
    setButton('search');
    if (this.customFunctionsToRender.length) {
      this.functionButtons = this.functionButtons.concat(this.customFunctionsToRender);
    }
    setButton('about');
    setButton('language');
    setButton('apps');
    setButton('user');
    setButton('menu');
  }
  _renderPaneToggle() {
    const classes = {
      'pane-toggle': true,
      'selected': this.paneToggleActive
    };
    return this.showPaneToggle ? html`
        <davinci-icon-ref
          class="${classMap(classes)}"
          .src="${paneToggleIcon}"
          @click="${this._toggleNavigationPane}"
        ></davinci-icon-ref>
      ` : nothing;
  }
  _renderLogo() {
    let logo = html`
      <div class="logo" title="${ifDefined(this.logoTitle)}">${SICK_LOGO}</div>
    `;
    if (this.logoUrl) {
      logo = html`
        <img
          class="logo custom"
          src="${this.logoUrl}"
          alt="${ifDefined(this.logoTitle)}"
          title="${ifDefined(this.logoTitle)}"
        />
      `;
    }
    return logo;
  }
  _renderDivider() {
    return this.appName && this.functionButtons.length ? html`<div class="divider"></div>` : nothing;
  }
  _renderFunctionButtons() {
    return this.functionButtons.length ? this.functionButtons.map(button => this._renderFunctionButton(button)) : nothing;
  }
  _renderFunctionButton(button) {
    const clickHandler = event => {
      event.stopPropagation();
      this.buttonClickEvent.emit({
        id: button.id,
        event,
        buttonElement: this.shadowRoot.querySelector('.function-button.' + button.id)
      });
    };
    return html`
      <davinci-icon-ref
        class="function-button ${button.id}"
        data-id="${button.id}"
        .src="${button.iconSrc}"
        title="${button.title}"
        @click="${clickHandler}"
      ></davinci-icon-ref>
    `;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "showPaneToggle", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "paneToggleActive", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "logoUrl", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "logoTitle", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "appName", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "about", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "apps", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "language", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "menu", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "search", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "user", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "buttonTitles", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "customFunctions", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "paneToggleEvent", [_dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "buttonClickEvent", [_dec30, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "customFunctionsToRender", [_dec32, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "functionButtons", [_dec34, _dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
})), _class2)) || _class);
